module.exports = __webpack_public_path__ + "static/15-ec523def1bc9e3563713440a1667973b.jpg";